import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { Box, Text } from '@chakra-ui/react'
import Button from 'src/components/Button/Button'
import { SlideOverPane } from 'src/components/Card'
import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon'
import { PlaceRating } from 'src/components/Maps/KioskGoogleMap'
import { isEmpty } from 'src/utils/helpers'
import intlMessages from 'src/components/Maps/translations'
import styles from './GoogleMapList.module.less'
import { SidebarCard } from 'src/components/SidebarCard/SidebarCard'

class GoogleMapList extends Component {
  onItemSelect = (e, item, closeSlideOverPane) => {
    e.preventDefault()

    this.props.onItemSelect(item)

    closeSlideOverPane()
  }

  render() {
    const {
      intl,
      items,
      isWidget,
      containerRef,
      isVisible,
      onAfterLoad,
      classes,
      notificationHeight,
      isNotificationHidden,
    } = this.props

    if (isEmpty(items) || !Array.isArray(items)) {
      return ''
    }

    return (
      <SlideOverPane
        isWidget={isWidget}
        containerRef={containerRef}
        isVisible={isVisible}
        onAfterLoad={onAfterLoad}
        notificationHeight={notificationHeight}
        isNotificationHidden={isNotificationHidden}
        fallbackTriggerShow={() => (
          <Button parentClasses={classes}>
            <Box mr={'10px'}>
              <FontAwesomeIconComponent icon={['far', 'list-ul']} size='xs' type='white' />
            </Box>
            <Text variant='white'>{intl.formatMessage(intlMessages.listView)}</Text>
          </Button>
        )}
        fallbackTriggerHide={() => (
          <Button parentClasses={classes}>
            <Box mr={'10px'}>
              <FontAwesomeIconComponent icon={['far', 'map']} size='xs' type='white' />
            </Box>
            <Text variant='white'>{intl.formatMessage(intlMessages.mapView)}</Text>
          </Button>
        )}
      >
        {({ closeSlideOverPane }) => (
          <div className={styles.list}>
            {items.map((item, key) => {
              return (
                <SidebarCard
                  item={{ ...item, hideArrow: true }}
                  title={item.name}
                  isFullWidth={true}
                  isProfile={true}
                  noMargin={false}
                  icon={
                    <Box opacity={0.5}>
                      <FontAwesomeIconComponent
                        icon={item.placeIconName}
                        size='sm'
                        type='primary'
                      />
                    </Box>
                  }
                  key={`map-list-item-${key}`}
                  onClick={e => this.onItemSelect(e, item, closeSlideOverPane)}
                >
                  <>
                    <PlaceRating place={item} />
                    <Text
                      fontSize={'13px'}
                      opacity={0.7}
                      overflow={'hidden'}
                      textOverflow={'ellipsis'}
                    >
                      {item.vicinity}
                    </Text>
                  </>
                </SidebarCard>
              )
            })}
          </div>
        )}
      </SlideOverPane>
    )
  }
}

GoogleMapList.propTypes = {
  items: PropTypes.array.isRequired,
  isWidget: PropTypes.bool.isRequired,
  onItemSelect: PropTypes.func.isRequired,
  onAfterLoad: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
  // Provided from withStyles()
  classes: PropTypes.object.isRequired,
}

export default injectIntl(GoogleMapList)
